import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const iconsGallery: ThemeUICSSObject = {
  select: {
    width: '100px',
  },

  '.controls': {
    alignItems: 'center',
    display: 'flex',
    gap: '3',
    p: 3,
    position: 'sticky',
    top: 0,
  },

  '.grid': {
    display: 'grid',
    pt: 6,
    gridTemplateColumns: 'repeat(10, 1fr)',
    gap: 3,

    '.iconsBox': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 3,

      '&:hover': {
        backgroundColor: '#0001',
      },
    },

    '.icons': {
      display: 'flex',
      gap: 3,
      p: 3,
      alignItems: 'end',
    },
  },
};

export default iconsGallery;
